import { useState } from "react";

function ProductImage({ src, alt, size = "order" }) {
  const [imageFailed, setImageFailed] = useState(false);
  const sizeClasses =
    size === "shipment" ? "w-14 h-16" : "w-16 h-20";

  return (
    <div
      className={`${sizeClasses} flex shrink-0 items-center justify-center overflow-hidden rounded-lg border border-[#EAEAEB] bg-[#F7F7F8]`}
    >
      {src && !imageFailed ? (
        <img
          alt={alt || "Product"}
          className="w-full h-full object-contain"
          onError={() => setImageFailed(true)}
          src={src}
        />
      ) : (
        <span
          aria-hidden="true"
          className="text-lg font-semibold uppercase text-[#B3B6BC]"
        >
          {(alt || "P").trim().charAt(0) || "P"}
        </span>
      )}
    </div>
  );
}

export default ProductImage;
